export const footerLogo = require('./images/footer-icon.png');
export const headerLogo = require('./images/header-icon.png');
export const validateLogo = require('./images/Validate.png');
export const cancelLogo = require('./images/cancel.png');
export const successLogo = require('./images/SuccessTick.png');
export const recordNotFound = require('./images/NotFound.png');
export const myHubAndroidQr = require('./images/MyHubAndroid.png');
export const myHubIosQr = require('./images/MyHubiOS.png');
